import { render, staticRenderFns } from "./LeaveEditor.vue?vue&type=template&id=06824939"
import script from "./LeaveEditor.vue?vue&type=script&lang=js"
export * from "./LeaveEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports